export default "__VITE_ASSET__C3C_uyC$__"